import { Trans } from '@lingui/react/macro';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@repo/videa-components';

import type { VoiceNoteTemplate } from '@/react-query/videa-notes/useVoiceNoteTemplates';
import { capitalize } from '@/utils/string';

interface TemplateDetailsDialogProps {
  template: VoiceNoteTemplate;
  isOpen: boolean;
  onClose: () => void;
}

export const TemplateDetailsDialog = ({
  template,
  isOpen,
  onClose,
}: TemplateDetailsDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="vai-max-w-2xl vai-max-h-[80vh] vai-overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="vai-text-xl vai-font-semibold vai-text-gray-900">
          {template.name}
        </DialogTitle>
        <DialogDescription className="vai-text-sm vai-text-gray-600">
          {template.description || <Trans>Template Details</Trans>}
        </DialogDescription>
      </DialogHeader>
      <div className="vai-mt-2">
        <div>
          <div className="vai-grid vai-grid-cols-2 vai-gap-4" />
          {template.createdBy && (
            <div>
              <h3 className="vai-text-sm vai-font-medium vai-text-gray-500 vai-mb-1">
                <Trans>Created By</Trans>
              </h3>
              <p className="vai-text-sm vai-text-gray-900">
                {template.createdBy.name}
                <span className="vai-text-gray-500 vai-ml-2">
                  ({capitalize(template.createdBy.type)})
                </span>
              </p>
            </div>
          )}
        </div>
        {template.sections && template.sections.length > 0 && (
          <div>
            <h3 className="vai-text-sm vai-font-medium vai-text-gray-900 vai-mb-3">
              <Trans>Sections</Trans>
            </h3>
            <div className="vai-space-y-1">
              {template.sections
                .sort((a, b) => a.order - b.order)
                .map((section) => (
                  <div
                    key={section.id}
                    className="vai-p-4 vai-bg-gray-50 vai-rounded-lg vai-border vai-border-gray-200"
                  >
                    <div className="vai-flex vai-items-start vai-justify-between">
                      <div className="vai-flex-1">
                        <div className="vai-flex vai-items-center vai-gap-2 vai-mb-1">
                          <span className="vai-inline-flex vai-items-center vai-justify-center vai-w-6 vai-h-6 vai-rounded-full vai-bg-blue-100 vai-text-blue-600 vai-text-xs vai-font-semibold">
                            {section.order}
                          </span>
                          <h4 className="vai-text-sm vai-font-semibold vai-text-gray-900">
                            {section.label}
                          </h4>
                        </div>
                        {section.description && (
                          <p className="vai-text-sm vai-text-gray-600 vai-ml-8">
                            {section.description}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
